export const summaryData = {
  packageDetails: {
    label: 'Package Details',
    column: [
      {
        key: 'trackingId',
        label: 'Tracking Id'
      },
      {
        key: 'orderNo',
        label: 'Order No'
      },
      {
        key: 'milestoneCarrierStatus',
        label: 'Milestone Status'
      },
      {
        key: 'milestoneRawStatus',
        label: 'Current Activity'
      },
      {
        key: 'lastUpdate',
        label: 'Date & Time',
        formatter: 'dateFormatterTZ'
      },
      {
        key: 'eta',
        label: 'ETA',
        formatter: 'dateFormatterTZ'
      },
      {
        key: 'packageStatus',
        label: 'Trip Status',
        formatter: 'startCase'
      },
      {
        key: 'exceptionCount',
        label: 'Exception'
      },
      {
        key: 'packageType',
        label: 'Package Type'
      },
      {
        key: 'volumetricWeight',
        label: 'Volumetric Weight'
      },
      {
        key: 'uomVolumetricWeight',
        label: 'Volumetric Weight Unit'
      },
      {
        key: 'dimensions',
        label: 'Package Dimension'
      },
      {
        key: 'groupId',
        label: 'Group Id'
      }
    ]
  },
  originDetails: {
    label: 'Origin Details',
    column: [
      {
        key: 'originDetails.city',
        label: 'City'
      },
      {
        key: 'originDetails.pincode',
        label: 'Pincode'
      },
      {
        key: 'originDetails.consignerName',
        label: 'Consigner'
      },
      {
        key: 'originDetails.consignerAddress',
        label: 'Consigner address'
      },
      {
        key: 'originDetails.consignerContact',
        label: 'Consigner contact no'
      },
      {
        key: 'originDetails.consignerEmail',
        label: 'Consigner email id'
      }
    ]
  },
  destinationDetails: {
    label: 'Destination Details',
    column: [
      {
        key: 'destinationDetails.city',
        label: 'City'
      },
      {
        key: 'destinationDetails.pincode',
        label: 'Pincode'
      },
      {
        key: 'destinationDetails.consignerName',
        label: 'Consignee'
      },
      {
        key: 'destinationDetails.consignerAddress',
        label: 'Consignee address'
      },
      {
        key: 'destinationDetails.consignerContact',
        label: 'Consignee contact no'
      },
      {
        key: 'destinationDetails.consignerEmail',
        label: 'Consignee email id'
      }
    ]
  },
  carrierDetails: {
    label: 'Carrier Details',
    column: [
      {
        key: 'carrierName',
        label: 'Carrier Name'
      },
      {
        key: 'carrierCode',
        label: 'Carrier Code'
      },
      {
        key: 'typeOfService',
        label: 'Service Type'
      }
    ]
  }
}

export const parcelConfig = {
  styling: {
    style: { background: '#F0F2F5' },
    layoutStyle: {},
    className: '',
    variant: {}
  },
  config: {
    tabsComponent: {
      summaryParcel: {
        showPackageDetails: true,
        label: 'Summary',
        component: 'summaryParcel',
        keyData: { ...summaryData }
      },
      parcelException: {
        showPackageDetails: true,
        label: 'Exceptions',
        component: 'parcelException'
      },
      parcelItemDetails: {
        showPackageDetails: false,
        label: 'Item Details',
        component: 'parcelItemDetails',
        columns: [
          {
            label: 'Item Id',
            key: 'itemReferenceNumber'
          },
          {
            label: 'Item Name',
            key: 'itemName'
          },
          {
            label: 'Quantity',
            key: 'itemQuantity'
          },
          {
            label: 'Child Awb No.',
            key: 'childAwbNo'
          },
          {
            label: 'Weight',
            key: 'itemWeight'
          },
          {
            label: 'Dimension',
            key: 'itemDimension'
          },
          {
            label: 'Volumetric Weight',
            key: 'itemVolumetricWeight'
          }
        ]
      },
      parcelEpod: {
        showPackageDetails: true,
        label: 'EPOD',
        component: 'parcelEpod'
      }
    },
    isShared: 'true',
    summaryURL: '/api/v1/parcels/public_show/',
    shareURL: ``,
    shareQueryParams: {
      resource_type: 'shipment',
      resource_id: ''
    },
    timeLineUrl: '/api/v1/parcels/public_get_timeline',
    subscribeURL: `/api/v3/trip/subscribe/`
  }
}
